
export const farm = {
  'farm.profileTitle': 'Farm Profile',
  'farm.profileSubtitle': 'Essential farm information and metrics',
  'farm.clientProfileTitle': 'Client Profile',
  'farm.clientProfileSubtitle': 'Client details and contact information',
  'farm.assistantTitle': 'Sustainability Assistant',
  'farm.assistantDesc': 'Get personalized recommendations',
  'farm.assistantPlaceholder': 'Ask me about sustainable practices, funding opportunities, compliance...',
  'farm.assistantResponse': 'Based on your farm profile, I suggest exploring water-efficient irrigation systems. There are several EU grants available for this type of upgrade that could cover up to 60% of costs. Would you like more information?',
  'farm.documentTitle': 'Documents',
  'farm.documentSubtitle': 'View and manage farm documents',
  'farm.regulatoryOverview': 'Regulatory Overview',
  'farm.capCompliance': 'CAP Compliance',
  'farm.emissionsScore': 'Emissions Score',
  'farm.ecoSchemeEligibility': 'Eco-scheme Eligibility',
  'farm.aiUpdates': 'AI Updates',
  'farm.aiUpdateInitial': 'How can I help improve my farm\'s sustainability score?',
  'farm.aiUpdateResponse': 'Based on your current metrics, focusing on water management and biodiversity corridors would have the biggest impact on your sustainability score.',
  'farm.regionOpportunityScore': 'Region Opportunity Score',
  'farm.grantDensity': 'Grant Density',
  'farm.politicalFriendliness': 'Policy Friendliness',
  'farm.recentApprovals': 'Recent Approvals',
  'farm.high': 'High',
  'farm.medium': 'Medium',
  'farm.veryHigh': 'Very High',
  'farm.low': 'Low',
  'farm.attachedSubsidies': 'Attached Subsidies',
  'farm.manuallyAttached': 'Manually Attached',
  'farm.automaticallyMatched': 'Automatically Matched',
} as const;
